import delay from 'onyx-common/delay'

const uiDelay = (cb, ms = 20) => {
  return delay(cb, ms)
}

export default uiDelay
